const state = {
	ticketsActiveTabLink: "ACTIVE",
	ticketStores: [],
	ticketStoresLocation:[],
	selectedOutlet: "",
	ticketTitle: "",
	ticketList: [],
	showTicketsForm: false,
	ticketDetails: {
		title: "",
		priority: "",
		department: "",
	},
	ticketTypes: [
		{
			name: "Task",
			value: "Task",
		},
		{
			name: "Maintenance",
			value: "Maintenance",
		},
		{
			name: "Other",
			value: "Other",
		},
	],
	ticketDepartments: [],
	ticketPriorities: [
		{
			name: "High",
			value: "high",
		},
		{
			name: "Medium",
			value: "medium",
		},
		{
			name: "Low",
			value: "low",
		},
	],
	showReportIssue: false,
	issueTypeList: [],
	reportIssueInfo: {
		incident: "",
		title: "",
		selectedReportOutlet: "",
		priority: "",
		description: "",
	},
	showAssignTicketModal: false,
	pagination: null,
	ticket_list_count: 0,
	ticketReports: [],
	ticketsSummary: {
		total_incidents: 0,
		open_incidents: 0,
		inprogress_incidents: 0,
		closed_incidents: 0,
		completion_rate: 0,
	},
	showIncidentStatus: false,
	ticketsLoader: false,
	reportsLoader: false,
	reportOutlet: "",
	storeUserList: [],
	progressStatus: [
		{
			name: "In Progress",
			value: "inprogress",
		},
		{
			name: "On Hold",
			value: "onhold",
		},
		{
			name: "Completed",
			value: "completed",
		},
	],
	confirmTicket: true,
	allFiles: [],
	uploadedFiles: [],
	detailedFileList: [],
	isLoading: false,
	ticketSelectedDepartments: [],
	searchDepartmentName: "",
	priorityList: ["low", "medium", "high"],
	selectedProirities: [],
	searchedPriority: "",
	ticketStoreDepartment: "",
	showImage: false,
	userGroups: [],
	userDesignations: [],
	resolutionSteps: [],
	isUserFixer: false,
	isUserAdmin: false,
	showPrioritiesModal: false,
	slaTimings: [],
	showTicketTypeToggleModal: false,
	ticketTypeTitle: {
		name: "",
	},
	activeUserGroupId: "",
	userGroupDetails: [],
	ticketsPerPage: 10,
	ticketsCurrentPage: 1,
	reportPerPage: 10,
	reportCurrentPage: 1,
	// Ticket update params
	locationVisit: "remotely",
	stepsTaken: [],
	ticketDescription: "",
	ticketStatus: "assigned",
	ticketFileList: [],
	deletedStepsTakenList: [],
	selectedStepId: "",
	reportIssueFiles: [],
	searchedUserGroupName: "",
	selectedUserGroups: [],
	searchedPriorityName: "",
	selectedPriorities: [],
	escalationDepartmentsOne: [],
	escalationDepartmentsTwo: [],
	escalationDepartmentsThree: [],
	designationUsers: [],
	designationUsers_1: [],
	designationUsers_2: [],
	designationUsers_3: [],
	ticketsTableDateAscending: false,
	ticketsTableDateDescending: true,
	searchedReportLocation: "",
	searchedReportCategory: "",
	selectedReportLocations: [],
	searchedReportPriority: "",
	selectedReportPriority: [],
	selectedReportCategory: [],
	searchedReportAssignedTo: "",
	selectedReportAssignedTo: [],

	searchedTicketSLA: "",
	selectedTicketsSLA: [],
	daysArr: [],
	hoursArr: [],
	minSecArr: [],
	dayTimeOptions: [],
	showReissueModal: false,
	reissueDescription: "",
	reissueFiles: [],
	showTicketAttachmentsPopup: false,
	attachmentModalFiles: [],
	userCanUpdateTicket: false,
	userCanCloseTicket: false,
	ticketOnHoldDescription: "",
	ticketCategoryList: [],
	ticketsPriorityList: [],
	ticketAssignedToList: [],
	searchedReportTicketReissued: "",
	selectedReportTicketReissued: [],
	ticketsReissuedList: [],
	ticketsSlaViolationList: [],
	searchedReportSLAViolation: "",
	selectedReportSLAViolation: [],
	ticketsStatusList: [],
	selectedReportStatus: [],
	searchedReportStatus: "",
	ticketsTableTimeAscending: false,
	ticketsTableTimeDescending: true,
};

const mutations = {
	updateTicketsTableTimeDescending: (state, payload) => {
		state.ticketsTableTimeDescending = payload;
	},
	updateTicketsTableTimeAscending: (state, payload) => {
		state.ticketsTableTimeAscending = payload;
	},
	updateSearchedReportStatus: (state, payload) => {
		state.searchedReportStatus = payload;
	},
	updateSelectedReportStatus: (state, payload) => {
		state.selectedReportStatus = payload;
	},
	updateTicketsStatusList: (state, payload) => {
		state.ticketsStatusList = payload;
	},
	updateSelectedReportSLAViolation: (state, payload) => {
		state.selectedReportSLAViolation = payload;
	},
	updateSearchedReportSLAViolation: (state, payload) => {
		state.searchedReportSLAViolation = payload;
	},
	updateTicketsSlaViolationList: (state, payload) => {
		state.ticketsSlaViolationList = payload;
	},
	updateTicketsReissuedList: (state, payload) => {
		state.ticketsReissuedList = payload;
	},
	updateSelectedReportTicketReissued: (state, payload) => {
		state.selectedReportTicketReissued = payload;
	},
	updateSearchedReportTicketReissued: (state, payload) => {
		state.searchedReportTicketReissued = payload;
	},
	updateTicketsActiveTabLink: (state, payload) => {
		state.ticketsActiveTabLink = payload;
	},
	updateTicketStores: (state, payload) => {
		state.ticketStores = payload;
	},
	updateTicketStoresLocation: (state, payload) => {
		state.ticketStoresLocation = payload;
	},
	updateTicketCategoryList: (state, payload) => {
		state.ticketCategoryList = payload;
	},
	updateTicketsPriorityList: (state, payload) => {
		state.ticketsPriorityList = payload;
	},
	updateTicketAssignedToList: (state, payload) => {
		state.ticketAssignedToList = payload;
	},
	updateSelectedStore: (state, payload) => {
		state.selectedOutlet = payload;
	},
	updateTicketTitle: (state, payload) => {
		state.ticketTitle = payload;
	},
	updateTicketList: (state, payload) => {
		state.ticketList = payload;
	},
	updateShowTicketsForm: (state, payload) => {
		state.showTicketsForm = payload;
	},
	updateTicketDetails: (state, payload) => {
		state.ticketDetails = payload;
	},
	updateTicketTypes: (state, payload) => {
		state.ticketTypes = payload;
	},
	updateTicketDepartments: (state, payload) => {
		state.ticketDepartments = payload;
	},
	updateTicketPriorities: (state, payload) => {
		state.ticketPriorities = payload;
	},
	updateShowReportIssue: (state, payload) => {
		state.showReportIssue = payload;
	},
	updateIssueTypeList: (state, payload) => {
		state.issueTypeList = payload;
	},
	updateReportIssueinfo: (state, payload) => {
		state.reportIssueInfo = payload;
	},
	updateAssignTicketModal: (state, payload) => {
		state.showAssignTicketModal = payload;
	},
	updateticket_list_count: (state, payload) => {
		state.ticket_list_count = payload;
	},
	updateCurrentPage(state, value) {
		state.pagination = value;
	  },
	updateTicketReports: (state, payload) => {
		state.ticketReports = payload;
	},
	updateTicketSummary: (state, payload) => {
		state.ticketsSummary = payload;
	},
	updateIncidentStatus: (state, payload) => {
		state.showIncidentStatus = payload;
	},
	updateTicketsLoader: (state, payload) => {
		state.ticketsLoader = payload;
	},
	updateReportsLoader: (state, payload) => {
		state.payload = payload;
	},
	updateReportOutlet: (state, payload) => {
		state.reportOutlet = payload;
	},
	updateStoreUserList(state, payload) {
		state.storeUserList = payload;
	},
	updateConfirmTicket: (state, payload) => {
		state.confirmTicket = payload;
	},
	updateAllFiles: (state, payload) => {
		state.allFiles = payload;
	},
	updateUploadedFiles: (state, payload) => {
		state.uploadedFiles = payload;
	},
	updateDetailedFileList: (state, payload) => {
		state.detailedFileList = payload;
	},
	updateIsLoading: (state, payload) => {
		state.isLoading = payload;
	},
	updateTicketSelectedDepartments: (state, payload) => {
		state.ticketSelectedDepartments = payload;
	},
	updateSearchDepartmentName: (state, payload) => {
		state.searchDepartmentName = payload;
	},
	updateSelectedPriorities: (state, payload) => {
		state.selectedProirities = payload;
	},
	updateSearchedPriority: (state, payload) => {
		state.searchedPriority = payload;
	},
	updateTicketStoreDepartment: (state, payload) => {
		state.ticketStoreDepartment = payload;
	},
	updateShowImage: (state, payload) => {
		state.showImage = payload;
	},
	updateUserGroups: (state, payload) => {
		state.userGroups = payload;
	},
	updateUserDesignations: (state, payload) => {
		state.userDesignations = payload;
	},
	updateResolutionSteps: (state, payload) => {
		state.resolutionSteps = payload;
	},
	updateIsUserFixer: (state, payload) => {
		state.isUserFixer = payload;
	},
	updateIsUserAdmin: (state, payload) => {
		state.isUserAdmin = payload;
	},
	updateShowPrioritiesModal: (state, payload) => {
		state.showPrioritiesModal = payload;
	},
	updateSlaTimings: (state, payload) => {
		state.slaTimings = payload;
	},
	updateShowTicketTypeToggleModal: (state, payload) => {
		state.showTicketTypeToggleModal = payload;
	},
	updateTicketTypeTitle: (state, payload) => {
		state.ticketTypeTitle = payload;
	},
	updateActiveUserGroupId: (state, payload) => {
		state.activeUserGroupId = payload;
	},
	updateUserGroupDetails: (state, payload) => {
		state.userGroupDetails = payload;
	},
	updateTicketsPerPage: (state, payload) => {
		state.ticketsPerPage = payload;
	},
	updateTicketsCurrentPage: (state, payload) => {
		state.ticketsCurrentPage = payload;
	},
	updateReportPerPage: (state, payload) => {
		state.reportPerPage = payload;
	},
	updateReportCurrentPage: (state, payload) => {
		state.reportCurrentPage = payload;
	},
	updateLocationVisit: (state, payload) => {
		state.locationVisit = payload;
	},
	updateStepsTaken: (state, payload) => {
		state.stepsTaken = payload;
	},
	updateTicketDescription: (state, payload) => {
		state.ticketDescription = payload;
	},
	updateTicketStatus: (state, payload) => {
		state.ticketStatus = payload;
	},
	updateTicketFileList: (state, payload) => {
		state.ticketFileList = payload;
	},
	updateDeletedStepsTakenList: (state, payload) => {
		state.deletedStepsTakenList = payload;
	},
	updateSelectedStepId: (state, payload) => {
		state.selectedStepId = payload;
	},
	updateReportIssueFiles: (state, payload) => {
		state.reportIssueFiles = payload;
	},
	updateSearchedUserGroupName: (state, payload) => {
		state.searchedUserGroupName = payload;
	},
	updateSelectedUserGroups: (state, payload) => {
		state.selectedUserGroups = payload;
	},
	updateSearchedPriorityName: (state, payload) => {
		state.searchedPriorityName = payload;
	},
	updateSelectedPriorities: (state, payload) => {
		state.selectedPriorities = payload;
	},
	updateEscalationDepartmentsOne: (state, payload) => {
		state.escalationDepartmentsOne = payload;
	},
	updateEscalationDepartmentsTwo: (state, payload) => {
		state.escalationDepartmentsTwo = payload;
	},
	updateEscalationDepartmentsThree: (state, payload) => {
		state.escalationDepartmentsThree = payload;
	},
	updateDesignationUsers: (state, payload) => {
		state.designationUsers = payload;
	},
	updateDesignationUsers_1: (state, payload) => {
		state.designationUsers_1 = payload;
	},
	updateDesignationUsers_2: (state, payload) => {
		state.designationUsers_2 = payload;
	},
	updateDesignationUsers_3: (state, payload) => {
		state.designationUsers_3 = payload;
	},
	updateTicketsTableDateAscending: (state, payload) => {
		state.ticketsTableDateAscending = payload;
	},
	updateTicketsTableDateDescending: (state, payload) => {
		state.ticketsTableDateDescending = payload;
	},
	updateSearchedReportLocation: (state, payload) => {
		state.searchedReportLocation = payload;
	},
	updateSearchedReportCategory: (state, payload) => {
		state.searchedReportCategory = payload;
	},
	updateSelectedReportCategory: (state, payload) => {
		state.selectedReportCategory = payload;
	},
	updateSearchedReportPriority: (state, payload) => {
		state.searchedReportPriority = payload;
	},
	updateSelectedReportPriority: (state, payload) => {
		state.selectedReportPriority = payload;
	},
	updateSelectedReportAssignedTo: (state, payload) => {
		state.selectedReportAssignedTo = payload;
	},
	updateSearchedReportAssignedTo: (state, payload) => {
		state.searchedReportAssignedTo = payload;
	},
	updateSelectedReportLocations: (state, payload) => {
		state.selectedReportLocations = payload;
	},
	updateSearchedTicketSLA: (state, payload) => {
		state.searchedTicketSLA = payload;
	},
	updateSelectedTicketsSLA: (state, payload) => {
		state.selectedTicketsSLA = payload;
	},
	updateDaysArr: (state, payload) => {
		state.daysArr = payload;
	},
	updateHoursArr: (state, payload) => {
		state.hoursArr = payload;
	},
	updateMinSecArr: (state, payload) => {
		state.minSecArr = payload;
	},
	updateDayTimeOptions: (state, payload) => {
		state.dayTimeOptions = payload;
	},
	updateShowReissueModal: (state, payload) => {
		state.showReissueModal = payload;
	},
	updateReissueFiles: (state, payload) => {
		state.reissueFiles = payload;
	},
	updateReissueDescription: (state, payload) => {
		state.reissueDescription = payload;
	},
	updateShowTicketAttachmentsPopup: (state, payload) => {
		state.showTicketAttachmentsPopup = payload;
	},
	updateAttachmentModalFiles: (state, payload) => {
		state.attachmentModalFiles = payload;
	},
	updateUserCanUpdateTicket: (state, payload) => {
		state.userCanUpdateTicket = payload;
	},
	updateUserCanCloseTicket: (state, payload) => {
		state.userCanCloseTicket = payload;
	},
	updateTicketOnHoldDescription: (state, payload) => {
		state.ticketOnHoldDescription = payload;
	},
};

export default {
	state,
	mutations,
	namespaced: true,
};
